import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, BookOpen, Pill } from 'lucide-react';
const bonuses = [{
  label: 'BONO 1',
  title: 'Lista de Compras Inteligente',
  desc: 'Ingredientes clave que encuentras en cualquier país para facilitar tu nutrición metabólica.',
  value: '$17',
  icon: <ShoppingBag size={24} className="text-sage-700" data-id="element-13" />
}, {
  label: 'BONO 2',
  title: 'Diario de Síntomas de 7 Días',
  desc: 'Una herramienta poderosa para identificar tus disparadores personales y medir tu progreso.',
  value: '$24',
  icon: <BookOpen size={24} className="text-sage-700" data-id="element-14" />
}, {
  label: 'BONO 3',
  title: 'Guía de Suplementos que SÍ funcionan',
  desc: 'No tires más tu dinero. Conoce exactamente qué comprar, qué dosis y cuándo tomarlo.',
  value: '$29',
  icon: <Pill size={24} className="text-sage-700" data-id="element-15" />
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function BonusesSection() {
  return <section className="py-20 md:py-32 bg-sage-800 text-cream" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-cream" data-id="element-19">
            Bonos Exclusivos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-sage-100/80 max-w-2xl mx-auto" data-id="element-20">
            Llévate estas herramientas complementarias completamente gratis al
            unirte hoy.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-21">
          {bonuses.map((bono, index) => <motion.div key={index} variants={itemVariants} className="bg-cream text-charcoal rounded-2xl p-8 relative overflow-hidden" data-id="element-22">
              <div className="absolute top-0 right-0 bg-sage-100 text-sage-800 text-xs font-bold px-4 py-1 rounded-bl-xl" data-id="element-23">
                {bono.label}
              </div>

              <div className="w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center mb-6 mt-2" data-id="element-24">
                {bono.icon}
              </div>

              <h3 className="text-xl font-bold mb-3" data-id="element-25">{bono.title}</h3>
              <p className="text-charcoal-light text-sm mb-6 leading-relaxed" data-id="element-26">
                {bono.desc}
              </p>

              <div className="mt-auto pt-4 border-t border-sage-100/50 flex items-center justify-between" data-id="element-27">
                <span className="text-sm text-charcoal-light" data-id="element-28">
                  Valor real: <span className="line-through" data-id="element-29">{bono.value}</span>
                </span>
                <span className="font-bold text-sage-700 uppercase text-sm tracking-wide" data-id="element-30">
                  GRATIS HOY
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}